module.exports = __webpack_public_path__ + "static/media/eggs.a235df2f.svg";